module.exports = __webpack_public_path__ + "static/img_scene1-97c02ba018efcf830f836a131ae385e1.png";